<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa header-toggle-icon" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times header-close-icon"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div>
      <table class="entity-table">
        <tbody>
        <tr>
          <td class="LayerLine1">Entity:</td>
          <td class="LayerData1">{{rowData?.LE_NAME}} : {{rowData?.LEID}} - {{rowData?.CDR_NO}} - {{rowData?.REPORTING_PERIOD}}</td>
          <td class="LayerLine1">Business:</td>
          <td class="LayerData1">{{rowData?.ME_CODE}} - {{rowData?.ME_NAME}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row adj-row">
      <div class="col-md-1 col-md-btn gt-edit-col"></div>
      <div class="col-md-4">
        <label class="adj-label">Adj Description:</label>
        <input type="text" class="form-control input-sm adj-input" placeholder="Enter Reclass Description" [(ngModel)]="adj_desc" (ngModelChange)="adjChange()">
        @if (desError) {
<div class="form-error-container">Adj Description is required</div>
}
      </div>
    </div>

    <hr class="accounts-separator">
    <!-- <div class="account-header">
      <div></div>
      <div class="centerText"><label>System Account</label></div>
      <div class="centerText"><label>Schdm Template</label></div>
      <div class="centerText"><label>Amount</label></div>
    </div> -->

    @for (account of accounts; track $index; let i = $index) {
<div class="row-space">
      <div class="account-header">
        <div></div>
        <div class="centerText"><label>System Account</label></div>
        <div class="centerText"><label>Schdm Template</label></div>
        <div class="centerText"><label>Amount</label></div>
      </div>
      <div class="account-grid">
        <button type="button" class="icon-btn" (click)="removeAccount(i)"><i class="fa fa-minus-circle color-red"></i></button>
        <div>
          <select gtwSearchableSelect class="form-control input-sm" [(ngModel)]="account.systemacct" (ngModelChange)="acctChange(i)">
            <option value="">Select</option>
            @for (s of sys_acc_dropdown_data; track $index) {
<option [value]="s">{{s}}</option>
}
          </select>
          @if (account.systemacctError) {
<div class="form-error-container">System account is required</div>
}
        </div>
        <div>
          <select gtwSearchableSelect class="form-control input-sm" [(ngModel)]="account.template" (ngModelChange)="templateChange(i)">
            <option value="">Select</option>
            @for (t of templatedata; track $index) {
<option [value]="t">{{t}}</option>
}
          </select>
          @if (account.templateError) {
<div class="form-error-container">Template is required</div>
}
        </div>
        <div>
          <div class="input-group amount-group">
            <span class="input-group-addon">USD</span>
            <input class="form-control input-sm rightText" [(ngModel)]="account.amount" (ngModelChange)="amtChange(i)">
          </div>
          @if (account.amtError) {
<div class="form-error-container">Amount cannot be zero</div>
}
        </div>
      </div>
    </div>
}

    <div class="row-space total-row">
      <button type="button" class="icon-btn" (click)="addTargetAccount()"><i class="fa fa-plus-circle color-green"></i></button>
      <div></div>
      <div></div>
      <div class="total-box">
        <div class="input-group amount-group">
          <span class="input-group-addon">USD</span>
          <input class="form-control input-sm rightText" readonly [ngModel]="reclassTotal">
        </div>
      </div>
    </div>
    @if (reclassTotal !== 0) {
<div class="total-error form-error-container">TBBS Reclass must net to 0</div>
}
  </div>
}
</div>

@if (showDeleteConfirmDialog) {
<div class="confirm-overlay">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="deleteConfirmConfig"
      [visible]="true"
      (confirmed)="onDeleteConfirm()"
      (cancelled)="onDeleteCancel()"
      (closed)="onDeleteCancel()">
    </gtw-confirmation-modal>
  </div>
</div>
}

@if (showLoadConfirmDialog) {
<div class="confirm-overlay">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="loadConfirmConfig"
      [visible]="true"
      (confirmed)="onLoadConfirm()"
      (cancelled)="onLoadCancel()"
      (closed)="onLoadCancel()">
    </gtw-confirmation-modal>
  </div>
</div>
}

<div class="modal-footer tbbs-footer" [hidden]="minimise || showFormLoader">
  <button class="save-button" type="button" [disabled]="reclassTotal !== 0 || crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save Reclass
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset Form</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

<div class="table-responsive existing-table-wrap" [hidden]="minimise || showFormLoader">
  <table class="table table-hover table-bordered table-striped table-condensed custom-table">
    <thead>
    <tr>
      <th style="text-align:center;">Edit</th>
      <th style="text-align:center;">Delete</th>
      <th>Adj Description</th>
      <th>System Account</th>
      <th>Schdm Template</th>
      <th>Amount</th>
      <th>Updated By</th>
      <th>Updated On</th>
    </tr>
    </thead>
    @if (existingLoading) {
<tbody>
    <tr><td class="loading-table" colspan="8"><i class="fa fa-2x fa-spinner fa-pulse"></i></td></tr>
    </tbody>
}
    @if (!existingLoading && (noRecords || !tbbsArray || tbbsArray.length === 0)) {
<tbody>
    <tr><td class="loading-table" colspan="8"><b>No Existing Reclasses</b></td></tr>
    </tbody>
}
    @if (!existingLoading && tbbsArray && tbbsArray.length > 0) {

      @for (group of tbbsArray; track $index) {
<tbody>
        @for (reclass of group.arrData; track $index; let idx = $index) {
<tr>
          @if (idx === 0) {
<td [attr.rowspan]="group.arrData.length" style="text-align:center;"><a href="javascript:void(0)" (click)="confirmLoadReclass(group)"><i class="fa fa-pencil"></i> Edit</a></td>
}
          @if (idx === 0) {
<td [attr.rowspan]="group.arrData.length" style="text-align:center;"><a href="javascript:void(0)" (click)="confirmDeleteReclass(reclass)"><i class="fa fa-times"></i></a></td>
}
          <td>{{reclass.ADJ_DESCRIPTION}}</td>
          <td>{{reclass.SYSTEM_ACCT_DESC}}</td>
          <td>{{reclass.SCHDM_TEMPLATE}}</td>
          <td class="rightText">{{reclass.AMOUNT | number:'1.0-0'}}</td>
          <td>{{reclass.UPDATED_BY}}</td>
          <td>{{reclass.UPDATED_ON}}</td>
        </tr>
}
      </tbody>
}
    
}
  </table>
</div>
